import { Link } from "react-router-dom";
import { quickEntries } from "@/mocks/site";

export default function QuickEntries() {
  return (
    <section className="w-full px-4 md:px-8 -mt-10 relative z-20">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
        {quickEntries.map((entry) => (
          <Link
            key={entry.label}
            to={entry.to}
            className="group flex items-center gap-3 md:gap-4 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/80 hover:border-accent-400 transition-all duration-300 cursor-pointer"
          >
            <span className="w-11 h-11 md:w-12 md:h-12 shrink-0 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 group-hover:bg-accent-500 group-hover:text-accent-950 transition-colors">
              <i className={`${entry.icon} text-xl md:text-2xl`}></i>
            </span>
            <span className="min-w-0">
              <span className="block font-heading text-sm md:text-base font-bold text-foreground-950">
                {entry.label}
              </span>
              <span className="block text-xs text-foreground-500 truncate mt-0.5">{entry.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}